import {fetchRecords} from "../services/ApplicationProductsService.ts";
import {ApplicationProduct} from "../types.ts";
import {useState} from "react";

export const useApplicationProducts = () => {

    const [items, setItems] = useState<ApplicationProduct[]>([]);

    // FETCH
    const handleFetchRecords = () => {
        return fetchRecords({})
            .then((response) => {
                setItems(response?.items as ApplicationProduct[])
            });
    };


    return {
        items,
        handleFetchRecords,
    };
};
